import 'jquery';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import './animations.js';
import './pallax-animation.js';
import './bg-parallax-animation.js';
import './dam-animation.js';
import './reservation.js'
import './new-design-animation.js'